import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import { merge, get, clone, set, findIndex } from 'lodash';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Icon, InputItem } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { getNewsList } from './action';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { base64ToBlob, blobToFile, readCookie, calcDate } from '../../../utils/common';
import Tloader from '../../../components/loader';
import LazyLoad from 'vanilla-lazyload';
import { Vh5Video } from '../../../components/videoPaler';
import { _track } from '../../../utils/track';
import './index.scss';
const mapStateToProps = state => {
	return {
		totalCount: state.CopyrightNewsReducers.totalCount,
		pageIndex: state.CopyrightNewsReducers.pageIndex,
		pageSize: state.CopyrightNewsReducers.pageSize,
		newsList: state.CopyrightNewsReducers.newsList
	};
};
let lazyLoadInstance = null;
function CopyrightNews(props) {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { newsList = [], totalCount, pageIndex, pageSize } = useMappedState(mapState);
	let [effectFlag, setEffectFlag] = useState(1);
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let dispatch = useDispatch();
	let handleLoadMore = resolve => {
		console.log('loading.....');
		console.log('pageSize', totalCount, pageIndex, pageSize);
		let userId = readCookie('copyrightuserId') || 0;
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		dispatch(
			getNewsList(
				{
					index: pageIndex + 1,
					limit: pageSize,
					sort: -1,
					userId: parseInt(userId, 10)
				},
				data => {
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_news_page',
						payload: {
							page_action_name: 'news-tploader-newslist'
						}
					});
					resolve();
				}
			)
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	function toActivity(item) {
		//处理微信授权的问题 通过history.push 方式会导致打开activity分享空白
		_track({
			trackName: 'toutu_news_page',
			payload: {
				id: item.id,
				page_action_name: 'news-location-newdetail'
			}
		});
		window.location.href = '/vpmobile/copyright/newsDetail/' + item.id;
	}
	function NewsItem(info) {
		let item = info.item;
		if (item.isCover === 1) {
			return (
				<div>
					{item.isTop ? (<span className="item-topping">置顶</span>) : ('')}
					<div className={item.isTop ? 'item-title isTop' : 'item-title'}>{item.title}</div>
					<div className="item-tips" style={{marginTop: '10px'}}>{item.crUserName} · {calcDate(item.releaseTime)}</div>
				</div>
			)
		} else if (item.isCover === 2) {
			return (
				<div style={{display: 'flex'}}>
					<div style={{flex: 1, paddingRight: '10px'}}>
						{item.isTop ? (<span className="item-topping">置顶</span>) : ('')}
						<div className={item.isTop ? 'item-title isTop' : 'item-title'}>{item.title}</div>
						<div className="item-tips" style={{marginTop: '18px'}}>{item.crUserName} · {calcDate(item.releaseTime)}</div>
					</div>
					<img style={{borderRadius: '4px'}} alt="" className="cover" src={item.coverOne} />
				</div>
			)
		} else if (item.isCover === 3) {
			return (
				<div>
					{item.isTop ? (<span className="item-topping">置顶</span>) : ('')}
					<div className={item.isTop ? 'item-title isTop' : 'item-title'}>{item.title}</div>
					<div style={{display: 'flex', justifyContent: 'space-between', marginTop: '4px', borderRadius: '4px', overflow: 'hidden'}}>
						<img alt="" className="cover" src={item.coverOne} />
						<img alt="" className="cover" src={item.coverTwo} />
						<img alt="" className="cover" src={item.coverThree} />
					</div>
					<div className="item-tips" style={{marginTop: '10px'}}>{item.crUserName} · {calcDate(item.releaseTime)}</div>
				</div>
			)
		}
	}
	useEffect(() => {
		console.log(cache, effectFlag, newsList);
		let userId = readCookie('copyrightuserId') || 0;
		if (!cache || (effectFlag === 1 && newsList.length === 0)) {
			setCache(true);
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 300
				// ... more custom settings?
			});
			dispatch(
				getNewsList({ index: 1, limit: 10, userId: parseInt(userId, 10) }, data => {
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_news_page',
						payload: {
							index: 1,
							limit: 5,
							page_action_name: 'news-init-newslist'
						}
					});
				})
			);
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台'
					});
					_track({
						trackName: 'toutu_news_page',
						payload: {
							page_action_name: 'news-init-wxconfig'
						}
					});
				})
			);
		} else if (effectFlag === 1 && cache) {
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 0
				// ... more custom settings?
			});
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
		}
	}, [dispatch, effectFlag, props, cache, newsList]);
	return (
		<div className="copyright copyright-news">
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							window.location.href = '/vpmobile/copyright/home/';
						}}>
						返回
					</label>
				</div>
				<span className="title">投图资讯</span>
			</header>
			<Tloader
				initializing={2}
				onRefresh={handleRefresh}
				hasMore={true}
				onLoadMore={handleLoadMore}
				autoLoadMore={pageIndex * pageSize < totalCount /*false不会触发onLoadMore*/}
				className="tloader some class">
				<section className="news-list">
					<ul>
						{get(newsList, 'length', '') && newsList.map((item = {}, index) => (
							<li key={'home-news-' + index}>
								<div className="item-box" to={'/vpmobile/copyright/newsDetail/' + item.id + '?' + item.id} onClick={toActivity.bind(this, item)}>
									{item.isCover ? <NewsItem item={item} /> : ('')}
								</div>
							</li>
						))}
					</ul>
					{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">---- 我是底线，不能更低了 ----</div>}
				</section>
			</Tloader>
		</div>
	);
}
export { CopyrightNews };
